<div class="setup-container container-fluid d-flex flex-column justify-content-center align-items-center" style="height: 100vh; background-color: #5dbcd2;">
    <div class="card p-5 text-center shadow-lg" style="min-width: 400px;">
        <h3 class="mb-4 text-primary">SHIVAM First-Time Setup</h3>
        <p class="text-muted">{{ statusText }}</p>

        <div class="progress mb-3" style="height: 25px;">
            <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" 
                 [style.width]="progress + '%'" 
                 [attr.aria-valuenow]="progress" aria-valuemin="0" aria-valuemax="100">
                {{ progress }}%
            </div>
        </div>
        
        <small class="text-secondary" *ngIf="totalStr">Total size: {{ totalStr }}</small>

        <div class="mt-4" *ngIf="!isSettingUp">
            <button class="btn btn-success px-4 py-2" (click)="triggerDownload()">Start Installation</button>
        </div>
    </div>
</div>
